/* #region Privacy Policy */
export const privacyTitle = "BOtag Technology BV Privacy Policy";

export const privacyLastUpdated = "01/09/2024";

export const privacyPolicyDownloadLink = "";

export const privacyPolicyIntroData = [
    "Welcome to <b>BOtag Technology BV</b>. Your privacy and the security of your personal data are of paramount importance to us.",
    "This Privacy Policy identifies the data controller for the processing activities described below, outlines how we collect, use, protect, and share information about our users (“you”) and your rights regarding your personal information.",
    "This Privacy Policy governs how we manage personal information gathered when you engage in transactions with us or navigate our website. It outlines BOtag Technology BV’s practices for processing your personal data and furnishes you with the details you have the right to know under relevant data protection legislation."
];

export const privacyPolicyData = [
    {
        title: "1. Who handles your data",
        html: `Unless specified differently, BOtag Technology BV (hereinafter referred as BOtag) acts as the data controller for the processing activities outlined below. <br />
        <div class='terms-text-tab1'>
        BOtag Technology BV <br />
        Kingsfordweg 151, 1043 GR Amsterdam <br />
        The Netherlands<br />
        VAT: NL855693009B01<br />
        REG: 64500187<br />
        info@botagtechnology.com
        </div>
        `
    },
    {
        title: "2. When we collect your data",
        html: `BOtag may collect your data when you visit any of the following websites owned by BOtag: botagtechnology.com and bostages.com and when you make purchases through botag.no, botag plugin or botag web or mobile applications.<br /><br />
        Botag may also collect your data when you communicate with us through email, sign to our newsletters or use any services or featured offered by Botag.
        `
    },
    {
        title: "3. What data we may collect",
        html: `Botag Technology BV may collect, process and store your personal data such us:<br />
        <ul class='terms-text-ul'>
            <li><b>Personal Identification Information</b>: Name, email address, phone number, address and other information you provide when creating an account.</li>
            <li><b>Transactional Data</b>: Details about purchases, preferences and interests (namely in products or services), and interactions with our platform.</li>
            <li><b>Technical and Usage Data</b>: IP address, browser type, operating system, page views, and navigation paths to understand how our platform is used.</li>
        </ul>`
    },
    {
        title: "4. Data we do not store",
        html: `BOtag does not store any payment method information on our systems. All payment processing is conducted through our trusted payment processors, who are responsible for securely storing and handling your payment details.
        `
    },
    {
        title: "5. How we use your information",
        html: `In order to provide and improve our services and products, your personal data may be processed on: <br />
                <ul class='terms-text-ul'>
                <li><b>Orders handling</b>: Name, email address, phone number, address and other information you provide when creating an account.</li>
                <li><b>Customer relationship management</b>: User account management; marketing communications such as sms, mms, newsletters and advertising in general; customer service; marketing events such us contests and public events; surveys; fulfillment of agreements entered between you and BOtag Technology BV and handling of requests from you.</li>
                <li><b>Legal compliance and security measures</b>: compliance with applicable laws and regulations; establishment, defense, and exercise of legal claims; prevention, detection, investigation, and combat of security breaches, fraud, and other potentially illegal activities.</li>
                <li><b>Research & Development</b>: Development of our products and services.</li>
                </ul>
        `
    },
    {
        title: "6. Legal framework",
        html: `BOtag handles and processes your personal data according to the GDPR legal framework <br />
                <ul class='terms-text-ul'>
                <li><b>Article 6.1.a:</b> Only if you have given prior consent in our platforms..</li>
                <li><b>Article 6.1.b:</b> compliance with applicable laws and regulations; establishment, defense, and exercise of legal claims; prevention, detection, investigation, and combat of security breaches, fraud, and other potentially illegal activities.</li>
                <li><b>Article 6.1.c:</b> To comply with accounting obligations and others.</li>
                <li><b>Article 6.1.f:</b> To conduct marketing activities and/or analytics..</li>
                <li><b>Article 6.1.f and 9.2.f:</b> To prevent fraud or to establish, prosecute or defend legal claims..</li>
                </ul>
        `
    },
    {
        title: "7. Sharing your information",
        html: `To achieve the aforementioned objectives, we may grant access to your personal data: <br />
                <ul class='terms-text-ul'>
                <li>To data processors who, under an agreement with BOtag, assist in our operations, offering pertinent services, including: providers of IT services such as POS systems installed in physical stores; providers of delivery services;</li>
                <li>To data processors providers of stock such as physical stores or warehouses, or to providers of product information such as brands, with the exclusive purpose of: providing you with accurate information about real-time stock and prices; providing you with authentic product information; and handling and fulfilling orders placed by you through BOtag. Both brands and stores operate as independent data controllers of personal data, processing the information for their own purposes.</li>
                <li>To other data processors, under an agreement with BOtag, offer other pertinent services including but not limited to CRM systems providers, billing and payment systems providers, marketing services providers, IT services & support providers, website analytics and hosting services.</li>
                <li>When required by law or to protect the rights and safety of our users and the public.</li>
                <li>With your consent, or as part of a business transfer, merger, or sale of assets.revent fraud or to establish, prosecute or defend legal claims..</li>
                </ul>
        `
    },
    {
        title: "8. Data security",
        html: `We implement robust security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. Our platform is hosted on Microsoft Azure infrastructure, which adheres to high standards of security and data protection compliance. This ensures that your personal data is managed in a secure environment with state-of-the-art technological safeguards.
        `
    },
    {
        title: "9. Storage period",
        html: `
        <ul class='terms-text-ul'>
            <li>Personal data related to your purchases is initially stored for three years following your most recent transaction.</li>
            <li>Data incorporated into financial records is retained for five years beyond the conclusion of the corresponding fiscal year before it is removed.</li>
            <li>Records of your consent to marketing are maintained for one years after you withdraw your agreement to receive direct marketing communications.</li>
        </ul>
        <br />
        Circumstances may necessitate extending the retention period of personal data, such as to comply with legal obligations or to establish, pursue, or defend against legal claims.
        Additionally, data may be processed and preserved in an anonymized format for an extended period.
        `
    },
    {
        title: "10. Your Rights",
        html: `You have the right to access, correct, delete, or limit the use of your personal information. Please contact us if you wish to exercise these rights: info@botagtechnology.com
        `
    },
    {
        title: "11. Children’s Privacy",
        html: `BOtag is not intended for individuals under the age of 13. We do not knowingly collect personal information from children without parental consent.
        `
    },
    {
        title: "12. Changes to this Policy",
        html: `We may update this Privacy Policy from time to time. We will notify you of any significant changes and update the effective date at the top of this policy.
        `
    },
    {
        title: "13. Contact Us",
        html: `If you have any questions about this Privacy Policy, please contact us at:<br />
        <div class='terms-text-tab1'>
            BOtag Technology BV <br />
            Kingsfordweg 151, 1043 GR Amsterdam <br />
            The Netherlands <br />
            VAT: NL855693009B01 <br />
            REG: 64500187 <br />
            info@botagtechnology.com <br />
        </div>
        `
    }
];
/* #endregion */

/* #region Terms and Conditions */

export const termsAndConditionsTitle = "BOtag Technology BV Terms and Conditions";

export const termsAndConditionsLastUpdated = "07/05/2025";

export const termsAndConditionsDownloadLink = null;

export const termsAndConditionsIntroData = [
    /* "Our technology (BOtag technology), is owned by BOtag Technology BV, registered in Amsterdam, Netherlands, under the organization number 64500187, headquartered at Kingsfordweg 151, 1043 GR Amsterdam, Netherlands, and operated in Norway by its subsidiary BOtag Norge AS, registered under organization number 932017814 with our principal place of business at Tordenskiolds Gate 2, 0160 Oslo, Norway.",
    "By using our platforms and technology, you accept these Terms and Conditions in full; accordingly.If you disagree with these terms or any part of these terms, you must not use our platform."
    */
];

export const termsAndConditionsData = [
    {
        title: "1. Introduction",
        html: `Welcome to BOtag Technology BV ("BOtag"). These Terms and Conditions ("Terms") govern your use of our platform and services (collectively, the "Platform"), including BOstages, BOimages, and HeyBO. By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree, you must not use the Platform.
        `
    },
    {
        title: "2. Definitions",
        html: `<ul class='terms-text-ul'>
                    <li><b>“Platform”</b>: BOtag website, apps, BOstages (BOstageB & BOstageR), BOimages, HeyBO, and related services.</li>
                    <li><b>“User”</b>: Any individual or entity using the Platform (shoppers, Label Brands, Retail Brands).</li>
                    <li><b>“Merchant”</b>: Any business (Label Brand or Retail Brand) using BOstages or BOtag to sell or fulfill products.</li>
                    <li><b>“Label Brand:”</b>: A brand producing and labeling products under its own name.</li>
                    <li><b>“Retail Brand:”</b>: A brand operating one or more physical stores without its own labeled products.</li>
                    <li><b>“BOstageB:”</b>: The portal for Label Brands.</li>
                    <li><b>“BOstageR:”</b>: The portal for Retail Brands.</li>
                    <li><b>BOimages:”</b>: Interactive, shoppable marketing images created by Label or Retail Brands.</li>
                    <li><b>“HeyBO”</b>: The AI-driven consumer interface for searching, shopping, and checkout.</li>
                    <li><b>Trial Period:”</b>: The free-access period defined in Section 6.</li>
                    <li><b>“Stripe”</b>: Third-party payment provider used by BOtag.</li>
                </ul>
        `
    },
    {
        title: "3. Acceptance of Terms",
        html: `By using the Platform, you confirm that you have read, understood, and agree to these Terms. If you represent a business, you warrant authority to bind that entity.
        `
    },
    {
        title: "4. Changes to Terms",
        html: `BOtag may modify these Terms at any time. Updates are effective upon posting. Continued use indicates acceptance of revised Terms.
        `
    },
    {
        title: "5. User Accounts & Registration",
        html: `        
        <ul class='terms-text-ul'>
            <li>Users must register with accurate information and keep credentials secure.</li>
            <li>Merchants must provide any required POS integration or API credentials.</li>
            <li>BOtag reserves the right to suspend or terminate accounts for violations or suspicious activity.</li>
        </ul>
        `
    },
    {
        title: "6. Trial Period Terms",
        html: `
        <b>6.1 Duration & Eligibility</b>
        <ul class='terms-text-ul'>
            <li>Trial runs from account activation until 23:59 UTC on 31 July 2025.</li>
            <li>Trial period may be extended to coordinate with the launch of AW25 collections.</li>
            <li>Extension of the trial period will be communicated with at least 7 days' notice.</li>
            <li>All new BOstageB and BOstageR accounts, enrolled during the trial period are eligible.</li>
        </ul>
       <b>6.2 Access & Cancellation</b>
        <ul class='terms-text-ul'>
            <li>Full access to paid features is granted during the Trial Period at no charge.</li>
            <li>Users may cancel any time before trial end via <b>Billing → Cancel Subscription</b> with no fees.</li>
            <li>Upon cancellation, paid features end immediately; read‑only access remains until trial expiry.</li>
        </ul>
        <b>6.3 Automatic Conversion</b>
        <ul class='terms-text-ul'>
            <li>Unless canceled, accounts auto-convert to paid subscriptions at immediately after the trial period ends.</li>
            <li>BOtag will send a reminder at least 7 days before trial expiry.</li>
        </ul>
        `
    },
    {
        title: "7. Subscription & Billing",
        html: `
        <ul class='terms-text-ul'>
            <li><b>Brands (BOstageB): </b>2 000 kr/month per brand (includes up to 100 store connections; additional stores at 18,5 kr each with 10% 10 stores-bulk discount).</li>
            <li><b>Stores (BOstageR): </b>Free from monthly fees on the basic subscription plan, 200 kr/month per store (unlimited brand connections) on the paid subscription plan.</li>
            <li>Billing monthly in advance; users may upgrade, downgrade, or cancel as per Section 6.</li>
        </ul>
        `
    },
    {
        title: "8. Payments & Fees",
        html: `
        <ul class='terms-text-ul'>
            <li>All payments processed via Stripe.</li>
            <li>BOtag deducts its commission (currently 9,75–11,75% on item price) before remitting funds to merchants.</li>
            <li>Users agree to Stripe’s fees and terms.</li>
        </ul>
        `
    },
    {
        title: "9. Product Availability & Pricing",
        html: `
        <ul class='terms-text-ul'>
            <li>Inventory and pricing reflect real-time data from merchant POS systems.</li>
            <li>Orders confirmed only after merchant acceptance.</li>
            <li>If unavailable, BOtag attempts to fulfill via alternative stores and notifies the shopper.</li>
        </ul>
        `
    },
    {
        title: "10. Controlled Data Sharing",
        html: `
        <b>10.1 Retail Brand Data Sharing Options</b>
        </br>
        "When a Retail Brand enables data sharing in BOstageR, they must select one of the following options:"
        <ul class='terms-text-ul'>
            <li><b>Option 1: "No Stock Sharing</b></p>I do not want to share my stock data with any of my suppliers."</li>
            <li><b>Option 2: Limited Data Sharing</b></p>“I agree to share real-time stock and pricing data only for items featured in active BOimages,” provided that the connected Label Brand also meets all of these conditions:</li>
        <ol>
            <li>Maintains at least <b>10 active BOimages</b> at all times.</li>
            <li>Guarantees an average of <b>3 tagged items per BOimage.</b></li>
            <li>Publishes at least <b>3 new BOimages per month.</b></li>
        </ol>
            <li><b>Option 3: Full Data Sharing</b></p>“I agree to share real-time stock and pricing data for all products,” provided that the connected Label Brand also meets all of these conditions:
            <ol>
                <li>Maintains at least <b>15 active BOimages at all times.</b></li>
                <li>Guarantees an average of <b>3 tagged items per BOimage.</b></li>
                <li>Publishes at least 5 new BOimages per month.</li>
                <li>(Effective January 2026) Achieves a minimum 3% conversion rate from BOimage impressions to confirmed sales.</li>
            </ol>
            </li>
        </ul>
        </br>
        <b>10.2 Activation & Enforcement</b>
        <ul class='terms-text-ul'>
            <li>Once a Retail Brand selects Option 2 or Option 3, BOtag will verify the Label Brand’s compliance with the required conditions.</li>
            <li>If all conditions are met, BOtag will notify both parties and activate the agreed data feeds.</li>
            <li>If the Label Brand fails to maintain compliance, BOtag will suspend the associated data feeds and inform both parties, pending corrective action.</li>
        </ul>
        `
    },
    {
        title: "11. Digital Partnerships & Content License",
        html: `
        <b>11.1 Establishing Connections</b>
        <ul class='terms-text-ul'>
            <li>Label Brands invite, and Retail Brands may request, digital connections through BOstages.</li>
            <li>Acceptance triggers a partnership enabling mutual data and content exchange.</li>
        </ul>
        </br>
        <b>11.2 Content License</b>
        <ul class='terms-text-ul'>
            <li>Connected Retail Brands are granted a non‑exclusive, royalty‑free license to use, display, and distribute Product Data and BOimages from connected Label Brands solely for order fulfillment, inventory management, and promotion via the Platform.</li>
        </ul>
         </br>
        <b>11.3 Termination</b>
        <ul class='terms-text-ul'>
            <li>Either party may revoke connections at any time; content licenses terminate upon disconnection.</li>
        </ul>
        `
    },
    {
        title: "12. Intellectual Property & Data Ownership",
        html: `
        <b>12.1 BOtag IP</b>
        <ul class='terms-text-ul'>
            <li>BOtag retains all rights to Platform code, trademarks, and content.</li>
            <li>Users receive a limited license to use the Platform per these Terms.</li>
        </ul>
        </br>
        <b>12.2 User Data Ownership</b>
        <ul class='terms-text-ul'>
            <li>Merchants retain ownership of Product Data (descriptions, images, etc.) they upload.</li>
            <li>BOtag acquires no ownership; merchants grant BOtag a non‑exclusive license to process and display data for service provision.</li>
        </ul>
        </br>
        <b>12.3 Order Cancellations</b>
        <ul class='terms-text-ul'>
            <li>Merchants authorize BOtag to reproduce and display their Product Data within the Platform while their account is active.</li>
        </ul>
        `
    },
    {
        title: "13. Returns, Refunds & Cancellations",
        html: `
        <b>13.1 Seller of Record</b>
        <ul class='terms-text-ul'>
            <li>BOtag is the seller of record for HeyBO transactions.</li>
            <li>The store accepts a return policy of 14 days from the date of purchase.</li>
        </ul>
        </br>
        <b>13.2 Returns & Refunds</b>
        <ul class='terms-text-ul'>
            <li>Shoppers request returns directly to the stores or through HeyBO platform.</li>
            <li>The Store verifies receipts and declines or validates returns through POS; BOtag issues refunds the shoppers to the original payment method and activates a refund from the store balance in Stripe.</li>
            <li>Return shipping costs may be deducted. Returns in person to the store are free of charge.</li>
        </ul>
        </br>
        <b>13.3 Order Cancellations</b>
        <ul class='terms-text-ul'>
            <li>Shoppers may cancel before store processing; post‑processing cancellations follow the return procedure.</li>
        </ul>
        `
    },
    {
        title: "14. User Conduct",
        html: `
        <ul class='terms-text-ul'>
            <li>Users must comply with all applicable laws and provide accurate product listings.</li>
            <li>Fraud, misleading descriptions, or system manipulation will result in suspension or termination.</li>
        </ul>
        `
    },
    {
        title: "15. Privacy & Data Protection",
        html: `
        <ul class='terms-text-ul'>
            <li>Governed by BOtag’s Privacy Policy.</li>
            <li>BOtag complies with GDPR and relevant data protection laws.</li>
        </ul>
        `
    },
    {
        title: "16. Liability & Disclaimers",
        html: `
        <ul class='terms-text-ul'>
            <li>Platform provided "as is"; no warranties on accuracy or availability.</li>
            <li>BOtag not liable for indirect or consequential damages or for Stripe’s services.</li>
        </ul>
         `
    },
    {
        title: "17. Indemnification",
        html: `
        <ul class='terms-text-ul'>
            <li>Users indemnify BOtag against claims arising from their Platform use or breach of these Terms.</li>
        </ul>
        `
    },
    {
        title: "18. Termination and Suspension",
        html: `
        <ul class='terms-text-ul'>
            <li>BOtag may suspend or terminate accounts for violations or harmful activities, with notice when feasible.</li>
        </ul>
        `
    },
    {
        title: "19. Dispute Resolution",
        html: `
        <ul class='terms-text-ul'>
            <li>Disputes resolved via good‑faith negotiation or arbitration under Dutch law.</li>
        </ul>
        `
    },
    {
        title: "20. Governing Law",
        html: `
        <ul class='terms-text-ul'>
            <li>These Terms governed by the laws of the Netherlands; exclusive jurisdiction of its courts.</li>
        </ul>
        `
    },
    {
        title: "21. Modifications to the Platform",
        html: `
         <ul class='terms-text-ul'>
            <li>BOtag may modify or discontinue Platform features without notice; continued use constitutes acceptance.</li>
        </ul>
        `
    },
    {
        title: "22. Force Majeure",
        html: `
        <ul class='terms-text-ul'>
            <li>BOtag not liable for delays or failures due to events beyond reasonable control (e.g., natural disasters, strikes).</li>
        </ul>
        `
    }
];

/* #endregion */
